import { render, staticRenderFns } from "./HeadingTable.vue?vue&type=template&id=5387f926&scoped=true"
import script from "./HeadingTable.vue?vue&type=script&lang=js"
export * from "./HeadingTable.vue?vue&type=script&lang=js"
import style0 from "./HeadingTable.vue?vue&type=style&index=0&id=5387f926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387f926",
  null
  
)

export default component.exports